import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import qs from 'qs'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinCable = {
  async apiCable(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'list':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/cable_reel/common?${qs.stringify(arg.params)}`)
        )
        break
      case 'add':
        ;[err, res] = await To(wizStandardInstance.post('/api/cable_reel/common', arg.params))
        break
      case 'edit':
        ;[err, res] = await To(wizStandardInstance.patch('/api/cable_reel/common', arg.params))
        break
      case 'tag':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/basedata/tag/?siteId=${arg.params.siteId}&pageno=${arg.params.pageNo}&pagesize=${arg.params.pageSize}&code[$text]=${arg.params.code}&status=0&id=${arg.params.id}`
            )
          )
        )
        break
      case 'one':
        ;[err, res] = await To(wizStandardInstance.get(`/api/cable_reel/common/${arg.params.id}`))
        break
      case 'remove':
        ;[err, res] = await To(
          wizStandardInstance.delete(`/api/cable_reel/common/${arg.params.type}`, {
            data: arg.params.ids,
          })
        )
        break
      case 'upload':
        ;[err, res] = await To(
          wizStandardInstance.post(`/api/cable_reel/upload/${arg.params.type}`, arg.formData)
        )
        break
      case 'export':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/cable_reel/export?${qs.stringify(arg.params)}`)
        )
        break
      case 'record':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/design_review/record/${arg.params.id}`)
        )
        break
      case 'check':
        ;[err, res] = await To(wizStandardInstance.post('/api/basedata/design_review', arg.params))
        break
      case 'calculate':
        ;[err, res] = await To(
          wizStandardInstance.post(
            `/api/cable_reel/calculate/${arg.params.siteId}`,
            arg.params.modelList
          )
        )
        break
      case 'saveCalculate':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/cable_reel/calculate_result', arg.params.modelList)
        )
        break
      case 'getCableReelNo':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/cable_reel/cable_disc?${qs.stringify(arg.params)}`)
        )
        break
      case 'findByCabletray':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/cable_reel/find_cable_by_cabletray?siteid=${
              arg.params.siteId
            }&code=${encodeURIComponent(arg.params.code)}`
          )
        )
        break
      // 采购分盘-新增-编辑，采购批次从必填改为非必填，如果未填写则调用此接口进行校验，自动生成采购批次
      case 'purchaseBatch':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/cable_reel/cable_contract_verification?producttype=${arg.params.productType}`
          )
        )
        break
      case 'findIndex':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/cable_reel/common_id_location?${qs.stringify(arg.params)}`)
        )
        break
      default:
        console.log('no method')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinCable,
}
